import { useCallback, useMemo, useState } from 'react';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger, Icon, Icons } from '../../../../components';
import { DropdownPlacement, TextColor } from '../../../../types';
import ExplorerItemEndIcon from '../ExplorerItemEndIcon';
import { FolderActionType } from '../FolderActionModals';

interface ExplorerFolderActionsProps {
  isUsed: boolean;
  onClose: () => void;
  openFolderActionModal: (type: FolderActionType) => void;
}

const ExplorerFolderActions = ({ isUsed, onClose, openFolderActionModal }: ExplorerFolderActionsProps) => {
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);

  const onActionClick = useCallback(
    (type: FolderActionType) => {
      openFolderActionModal(type);
      onClose();
    },
    [openFolderActionModal, onClose]
  );

  const actions = useMemo(
    () => [
      {
        icon: Icon.FOLDER_EDIT,
        label: 'Rename',
        onClick: () => onActionClick(FolderActionType.EDIT),
      },
      {
        icon: Icon.FOLDER_MOVE,
        label: 'Move',
        onClick: () => onActionClick(FolderActionType.EDIT),
      },
      {
        disabled: isUsed,
        icon: <Icons icon={Icon.FOLDER_DELETE} color={TextColor.DESTRUCTIVE} />,
        label: 'Delete',
        tooltip: isUsed ? 'Cannot delete folder until all contents are removed.' : undefined,
        onClick: () => onActionClick(FolderActionType.DELETE),
      },
    ],
    [isUsed, onActionClick]
  );

  return (
    <Dropdown
      open={isMoreDropdownOpen}
      onOpenChange={(open) => {
        setIsMoreDropdownOpen(open);
        onClose();
      }}
      placement={DropdownPlacement.BOTTOM_START}
    >
      <DropdownTrigger>
        <ExplorerItemEndIcon
          active={isMoreDropdownOpen}
          icon={Icon.ELLIPSIS_VERTICAL}
          onClick={() => setIsMoreDropdownOpen(!isMoreDropdownOpen)}
        />
      </DropdownTrigger>
      <DropdownContent>
        {actions.map((action) => (
          <DropdownItem key={action.label} {...action} />
        ))}
      </DropdownContent>
    </Dropdown>
  );
};

export default ExplorerFolderActions;
